// Imports
import { Fragment, ReactNode, useEffect, useState } from "react";
import { angularEvents } from "../../bridge/angularEvents";
import { Formik, Field, FieldArray, Form, ErrorMessage, FormikProps, FormikConfig } from "formik";
import { reactEvents } from "../../bridge/reactEvents";

// Exports
export function ColourChange({articleId, initialArticleColours}: {articleId: number, initialArticleColours: ArticleColours}) {
    let [articleColours, setArticleColours] = useState(initialArticleColours);

    useEffect(() => {
        const unsub = angularEvents.articleColoursHasChanged.subscribe((newArticleColours: ArticleColours) => {
            console.log("Got the following articleColours: ", newArticleColours);
            
            const uniqueColourNames = newArticleColours.ArticleColours
                .map(colour => colour.ColourName)
                .filter((value, index, self) => self.indexOf(value) == index);

            console.log("Adding unique colour names to values");
            newArticleColours.UniqueColourNames = uniqueColourNames;
            setArticleColours(newArticleColours);
        });
        return () => {
            unsub();
          };
    }, []);

    // Render this if we haven't gotten the articleColours from backend yet
    if (!articleColours) {
        return (<div className="fa fa-clock-o"></div>);
    }

    // Render this if we have all the information we need to present the UI
    return (
        <>
            <h2> 
                Colour change for article with Id: { articleId }
            </ h2>
            <div>
                ArticleColours: { JSON.stringify(articleColours) }
            </ div>
            <Formik<ArticleColours>
                initialValues = { articleColours }
                onSubmit = { (values, formikHelpers) => onSubmitForm(values, formikHelpers) }>
                { renderForm }
            </ Formik>
        </>
    );
}

// Local functions
// function renderForm({ isSubmitting }: { isSubmitting: boolean }) : JSX.Element {
function renderForm(formikState: any) : JSX.Element {
    console.log("formikState: ", formikState)
    const { values, isSubmitting } = formikState;

    if (!Array.isArray(values.articleColours)) {
        return (<div>values.articleColours is not an array</div>)
    }

    return (
        <Form>
            <div>
                values: { JSON.stringify(values.articleColours) }
            </ div>
            <div>
                { values.articleColours.map((colour) => (<div> {JSON.stringify(colour)} </div>)) }
            </div>
            <Field as="select" name="articleColours">
                <option key="0" value="0">Select a type</option>
                    {
                     values.articleColours.map((colour) => (
                    <option key={colour.articleVariantId} value={colour.colourName}>
                        { colour.colourName }
                    </option>
                    ))
                    }
            </Field>
            <Field type="text" name="newColourName" placeholder=""></Field>
            <button type="submit" disabled={ isSubmitting }> Submit </button>
        </ Form>
    );
}

async function onSubmitForm(values: any, { setSubmitting } : { setSubmitting: Function }) {
    console.log("onSubmit with values: ", values);
    console.log("SetSubmitting: ", setSubmitting);
    // Do call to some backend
    reactEvents.saveColourChange.dispatch(values);
    // On call return, continue here
    setSubmitting(false);
}

// Classes
export class ArticleColours {
    ArticleId: number = 0;
    ArticleColours: ArticleColour[] = [];
    UniqueColourNames: string[] = [];
}
class ArticleColour {
    ArticleVariantId: number = 0;
    ColourName: string = "";
}
